import { takeLatest } from 'redux-saga/effects';
import {
  FILL_TIFD_WORKBOOK_REQUEST,
  GET_TIFD_REPORT_REQUEST,
  PREVIEW_TIFD_REPORT_REQUEST,
} from '../constants';
import { fillTifdWorkbookSaga } from './fillTifdWorkbookSaga';
import { loadTifdReportSaga } from './loadTifdReportSaga';
import { previewTifdReportSaga } from './previewTifdReportSaga';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* tifdSaga() {
  yield takeLatest(PREVIEW_TIFD_REPORT_REQUEST, previewTifdReportSaga);
  yield takeLatest(GET_TIFD_REPORT_REQUEST, loadTifdReportSaga);
  yield takeLatest(FILL_TIFD_WORKBOOK_REQUEST, fillTifdWorkbookSaga);
}
